function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 231",
    style: {
      stroke: "rgba(247,247,247,.7)",
      strokeWidth: 4,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 156,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 156,
    r: 154,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1979",
    d: "M39.483 111.275a4.652 4.652 0 0 1-3.288-7.94L64.936 74.6a4.649 4.649 0 0 1 6.575 6.575l-28.741 28.74a4.653 4.653 0 0 1-3.287 1.36z",
    transform: "translate(60.59 98.514)",
    style: {
      fill: "#288461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1980",
    d: "M41.315 122.438a4.654 4.654 0 0 1-3.412-7.817L60.71 90.1a4.653 4.653 0 0 1 6.823 6.327l-22.807 24.522a4.625 4.625 0 0 1-3.411 1.489z",
    transform: "translate(62.278 112.781)",
    style: {
      fill: "#288461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1981",
    d: "m30.739 84.4 37.709 14.7a18.336 18.336 0 0 0 16.745-1.746l34.466-22.574a2.226 2.226 0 0 1 3.116 3.056l-23 34.089a17.435 17.435 0 0 0-1.717 16.359l14.9 36.75a3.911 3.911 0 0 0 7.228-.021l54.076-135.797a3.861 3.861 0 0 0-5.046-4.947L30.76 77.294a3.781 3.781 0 0 0-.021 7.088z",
    transform: "translate(54.589 52.781)",
    style: {
      fill: "#288461"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSending);
export default __webpack_public_path__ + "static/media/sending.71a28037.svg";
export { ForwardRef as ReactComponent };